<mat-selection-list role="list" [(ngModel)]="audiencesSelected" (ngModelChange)="onModelChange()">
  <mat-list-option role="listitem" checkboxPosition="before" [value]="maskAudience.audienceId" [disabled]="maskAudience.readOnly" *ngFor="let maskAudience of sortedMaskAudiences">
    {{ maskAudience.audienceName }}
  </mat-list-option>
</mat-selection-list>
